import Slice9Panel from "../../../../../lib/html5-software-library/src/ranj/components/scale9/Slice9Panel";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import Config from "../../../core/config/Config";
import NGTVariableManager from "../../base/NGTVariableManager";
import StoryVariables from "../../../app/util/StoryVariables";

export default class ChatTimeIndicatorMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {RevisableLanguagePack} languagePack 
     * @param {Config} config 
     * @param {NGTVariableManager} variableManager 
     */
    constructor(target, dispatcher, languagePack, config, variableManager) {
        super(target, dispatcher);

        this._languagePack = languagePack;
        this._config = config;
        this._variableManager = variableManager;
    }

    initialize() {
        super.initialize();

        this._panel = new Slice9Panel(this._target.panel, this._target.panel.children.find(c => c instanceof createjs.Bitmap), Slice9Panel.HORIZONTAL);
    }

    setTime(value) {
        this._time = value;
        this.update();
    }

    update() {
        const timeDelta = this._time - this._getCurrentTime();
        const timeIndication = this._getTimeIndication(timeDelta);
        const timeIndicationLabel = this._languagePack.getText(timeIndication.lp)
            .replace(/{time}/g, Math.abs(timeDelta));

        this._setTimeLabel(timeIndicationLabel);
    }

    _setTimeLabel(value) {
        this._target.panel.textField.text = value;
        this._panel.update();
    }

    _getTimeIndication(timeDelta) {
        return this._config
            .getValue(`chat.timeIndication`)
            .find(ti => timeDelta <= ti.delta);
    }

    _getCurrentTime() {
        return this._variableManager.solve(StoryVariables.STORY_TIME);
    }
}